
<template>
  <!--管理员角色权限-->
  <div>
    <!--<a-input-search style="margin-bottom: 8px" placeholder="请搜索"/>-->
    <div class="all-select">
      <a-checkbox class="select-btn" @change="selectAll" :checked="checkAll" :indeterminate="indeterminate">全选</a-checkbox>
    </div>

    <a-tree
      showLine
      checkable
      @expand="onExpand"
      @check="onCheck"
      v-model="checkedKeys"
      :expandedKeys="expandedKeys"
      :autoExpandParent="autoExpandParent"
      :treeData="treeData"
    >
      <template slot="title" slot-scope="{title}">
        <span v-if="title.indexOf(searchValue) > -1">
          {{title.substr(0, title.indexOf(searchValue))}}
          <span style="color: #f50">{{searchValue}}</span>
          {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
        </span>
        <span v-else>{{title}}</span>
      </template>
    </a-tree>
    <a-button :style="{marginTop: '20px'}" @click="submitConfig" type="primary" size="large">确定</a-button>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.roleList],
  name: 'roleAuth',
  data () {
    return {
      checkAll: false,
      indeterminate: true,
      apiAllValue: [],
      routeName: '',
      routeId: '',
      apiList: { // 获取api角色列表
        propertyApiAuth: 'property/role/apis_tree',
        manageApiAuth: '/apis/get_apis_tree',
        govApiAuth: '/government/role/apis_tree'
      },
      getAuthVal: { // 获取api或视图的权限值
        propertyApiAuth: 'property/role/apis/',
        propertyViewAuth: 'property/role/views/',
        manageApiAuth: 'roles/apis/',
        manageViewAuth: 'roles/views/',
        govApiAuth: '/government/role/apis/',
        govViewAuth: '/government/role/views/'
      },
      editAuth: { // 提交api或视图的权限值
        propertyApiAuth: { url: 'property/role/apis/', param: 'api_auth' },
        propertyViewAuth: { url: 'property/role/views/', param: 'view_auth' },
        manageApiAuth: { url: 'roles/apis/', param: 'api_auth' },
        manageViewAuth: { url: 'roles/views/', param: 'view_auth' },
        govViewAuth: { url: '/government/role/views/', param: 'view_auth' },
        govApiAuth: { url: '/government/role/apis/', param: 'api_auth' }
      },
      checkedKeys: [],
      halfCheckedKeys: [],
      expandedKeys: [], // 展开指定的节点
      searchValue: '',
      autoExpandParent: true, // 是否自动展开父节点
      treeData: []
    };
  },
  created () {
    this.routeName = this.$route.name;
    this.routeId = this.$route.query.id;
    let isRangeRoute = ['propertyApiAuth', 'manageApiAuth', 'govApiAuth'].some(el => el === this.routeName);
    if (isRangeRoute) {
      this.getApiList();
    } else {
      this.createViewTree();
      this.getAuth();
    }
  },
  methods: {
    /* 全选或反选 */
    selectAll (e) {
      if (e.target.checked) {
        Object.assign(this, {
          checkAll: true,
          indeterminate: false,
          checkedKeys: this.apiAllValue,
          halfCheckedKeys: []
        });
      } else {
        Object.assign(this, {
          checkAll: false,
          indeterminate: false,
          checkedKeys: [],
          halfCheckedKeys: []
        });
      }
      console.log('全选或反选checkedKeys: ', this.checkedKeys);
      console.log('全选或反选halfCheckedKeys: ', this.halfCheckedKeys);
    },
    /* 获取所有的value */
    getAllValue (data) {
      data && data.forEach((el) => {
        if (!this.apiAllValue.includes(el.key)) {
          this.apiAllValue.push(el.key);
        }
        if (el.children && el.children.length) {
          this.getAllValue(el.children);
        }
      });
    },
    /* 获取完整的api角色列表 */
    getApiList () {
      this.$get({
        url: `${this.apiList[this.routeName]}`,
        params: {}
      }).then(({data}) => {
        this.treeData = this.createApiTree(data);
        this.getAuth();
      });
    },
    /* api角色列表转成treeData格式 */
    createApiTree (data) {
      let arr = [];
      data && data.forEach((el) => {
        let childrenArr = [];
        el.children && el.children.forEach((item) => {
          let thirdChild = [];
          item.children && item.children.forEach((part) => {
            thirdChild.push({
              title: part.label,
              key: part.value
            });
          });

          childrenArr.push({
            title: item.label,
            key: item.value,
            children: thirdChild
          });
        });

        arr.push({
          title: el.label,
          key: el.value,
          children: childrenArr
        });
      });
      this.getAllValue(arr);
      return arr;
    },
    /* 获取api或视图的权限值 */
    getAuth () {
      this.$get({
        url: `${this.getAuthVal[this.routeName]}/${this.routeId}`,
        params: {}
      }).then(({data}) => {
        data && typeof data === 'string' && (data = JSON.parse(data));
        this.checkedKeys = data.c || [];
        this.halfCheckedKeys = data.h || [];
        this.selectBtnStatus();
      });
    },
    selectBtnStatus () {
      console.log('权限值', this.checkedKeys.length, this.apiAllValue.length);
      if (!this.checkedKeys.length && !this.halfCheckedKeys.length) {
        Object.assign(this, {
          checkAll: false,
          indeterminate: false
        });
      } else if (this.checkedKeys.length === this.apiAllValue.length) {
        Object.assign(this, {
          checkAll: true,
          indeterminate: false
        });
      } else {
        Object.assign(this, {
          checkAll: false,
          indeterminate: true
        });
      }
    },
    /* 提交权限设置 */
    submitConfig () {
      let param = {
        c: this.checkedKeys,
        h: this.halfCheckedKeys
      };
      param = JSON.stringify(param);
      this.$put({
        url: `${this.editAuth[this.routeName].url}${this.routeId}`,
        params: { [this.editAuth[this.routeName].param]: param }
      }).then((res) => {
        this.$message.success('设置成功！').then((res) => {
          this.$router.go(-1);
        });
      });
    },
    /* 选中复选框 */
    onCheck (checkedKeys, info) {
      this.checkedKeys = checkedKeys;
      this.halfCheckedKeys = info.halfCheckedKeys;
      console.log('onCheck-checkedKeys: ', this.checkedKeys);
      console.log('onCheck-halfCheckedKeys: ', this.halfCheckedKeys);

      // this.checkedKeys = e.checked;
      // this.halfCheckedKeys = e.halfChecked;
      // console.log('onCheck-e: ', e);
      // console.log('onCheck-info: ', info);

      this.selectBtnStatus();
    },

    /**
     * 展开指定的树节点
     * @param expandedKeys 选择的节点，下一步展开
     */
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false; // 关闭自动展开父节点
    },
    onChange (e) {
      const value = e.target.value;
      const expandedKeys = dataList.map((item) => {
        if (item.key.indexOf(value) > -1) {
          return getParentKey(item.key, gData);
        }
        return null;
      }).filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/managerCenter/role/roleAuth.vue